import { EditableDataGrid } from '../../../../builderPackage/components/editableDataGrid/editableDataGrid';
var TakeActionCatalog = function (props) {
    var onChange = props.onChange, value = props.value, error = props.error, name = props.name;
    var columns = [{
            field: 'AFR no.',
            headerName: 'AFR no.',
            headerAlign: 'center',
            minWidth: 100
        }, {
            field: 'PSG remarks',
            headerName: 'PSG remarks',
            minWidth: 150,
            flex: 1,
            editable: true
        }, {
            field: 'Action taken',
            headerName: 'Action taken',
            flex: 1
        }];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(EditableDataGrid, {
        columns: columns,
        onChange: onChange,
        disableToolbarActions: true,
        getToolbarActions: function (params) { return []; },
        dataGridHeaderProps: {},
        dataGridProps: {
            hideFooter: true,
            checkboxSelection: true
        },
        rows: [{
                id: 1,
                'FFR number.': 'FFR123456',
                'Action': 'View'
            }, {
                id: 2,
                'FFR number.': 'FFR654321',
                'Action': 'View'
            }]
    }));
};
export default TakeActionCatalog;
